/**
 * https://github.com/jsnanigans/vue-parallax-js
 * 滚动视差指令
 * 使用方法: v-parallax="0.2"
 * 高级用法: v-parallax.[modifier]="0.2", modifier的值可以为: centerX/absY
 */

class ParallaxJS {
	private os: any;
	public container: any;
	public _bindContainer: any;

	private items: any;
	private active: boolean;
	private tProp: string;

	public remove: Function;
	public add: Function;
	public update: Function;
	public move: Function;
	constructor (os: any) {
		this.os = os;
		this.container = null;
		this._bindContainer = () => {
			this.container = document.querySelector(this.os.container);
		};

		this.items = [];
		this.active = true;
		this.tProp =
			(window && (window as any).transformProp) ||
			(function (){
				const testEl: any = document ? document.createElement('div') : null;
				if (testEl && testEl.style.transform == null) {
					const vs = [ 'Webkit', 'Moz', 'ms' ];
					const t = 'Transform';
					for (const v of vs) {
						if (testEl.style[v + t] !== undefined) {
							return v + t;
						}
					}
				}
				return 'transform';
			})();
		this.remove = (el: HTMLElement, binding: any) => {
			for (let item of this.items) {
				if (item.el === el) {
					this.items.splice(this.items.indexOf(el), 1);
				}
			}
		};
		this.add = (el: HTMLElement, binding: any) => {
			if (!window) return;
			const value = binding.value;
			const arg = binding.arg;
			const style = (el as any).currentStyle || window.getComputedStyle(el);
			const mod = binding.modifiers;

			if (style.display === 'none') return;

			const height = mod.absY ? window.innerHeight : el.clientHeight || el.scrollHeight;

			const cl = this.os.className;
			if (typeof cl === 'string') {
				el.className = `${el.className} ${cl}`.trim();
			}

			this.items.push({
				el: el,
				iOT: el.offsetTop + (el as any).offsetParent.offsetTop - parseInt(style.marginTop),
				style,
				value,
				arg,
				mod,
				height,
				count: 0,
			});
		};
		this.update = () => {
			if (!window) return;
			this.items.forEach(function (item: any){
				const t = item.el;
				const n = t.currentStyle || window.getComputedStyle(t);

				item.height = item.mod.absY ? window.innerHeight : t.clientHeight || t.scrollHeight;
				if (t.offsetParent !== null) item.iOT = t.offsetTop + t.offsetParent.offsetTop - parseInt(n.marginTop);
			});
		};
		this.move = () => {
			if (!window) return;
			if (!this.active) return;
			if (window.innerWidth < this.os.minWidth || 0) {
				this.items.forEach((item: any) => {
					item.el.style[this.tProp] = ``;
				});

				return;
			}

			const sT = this.container ? this.container.scrollTop : window.scrollY || window.pageYOffset;
			const wH = window.innerHeight;

			this.items.forEach((item: any) => {
				const elH = item.height;
				const offset = item.iOT * -1 * item.value;
				const pos = (sT + wH - elH / 2 - wH / 2) * item.value + offset;

				window.requestAnimationFrame(() => {
					const cx = item.mod.centerX ? '-50%' : '0px';
					const props = `translate3d(${cx},${pos.toFixed(3)}px,0px)`;
					item.el.style[this.tProp] = props;
				});
			});
		};
	}
}

export default {
	bind (el: HTMLElement, binding: any, vnode: any) {
		const pax: any = new ParallaxJS({});
		const handler = () => {
			pax.update();
			pax.move(pax);
		};
		(el as any)._parallax_handler = handler;
		(el as any)._parallax_pax = pax;

		window.addEventListener('scroll', handler, { passive: true });
		window.addEventListener('resize', handler, { passive: true });
	},
	inserted (el: HTMLElement, binding: any, vnode: any) {
		(el as any)._parallax_pax.add(el, binding);
		(el as any)._parallax_pax.move((el as any)._parallax_pax);
	},
	update (el: HTMLElement, binding: any, vnode: any) {},
	componentUpdated (el: HTMLElement, binding: any, vnode: any) {},
	unbind (el: HTMLElement, binding: any, vnode: any) {
		(el as any)._parallax_pax.remove(el, binding);
		window.removeEventListener('scroll', (el as any)._parallax_handler);
		window.removeEventListener('resize', (el as any)._parallax_handler);
	},
};
